import React from "react"
import { Alert } from "@ui/Alert"
import { Button } from "@ui/Button"
import { Dialog } from "@ui/Dialog"

export default function AdhocBookingModal({
  isOpen,
  videoSpaceName,
  scheduledSpaceName,
  isSubmitting,
  error,
  onEnableAndMap,
  onMapWithoutEnabling,
  onCancel
}) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(o) => { if (!o) onCancel() }}>
      <Dialog.Content size="md">
        <Dialog.Header>
          <Dialog.Title>Enable Ad Hoc Booking?</Dialog.Title>
        </Dialog.Header>

        <Dialog.Body>
          <div className="text-sm text-webex-gray-700 dark:text-webex-gray-300 space-y-3">
            <p>
              The video space <strong className="text-webex-gray-1000 dark:text-white">"{videoSpaceName}"</strong> does
              not have ad hoc booking enabled on its device.
            </p>
            <p>
              Ad hoc booking allows the Enhanced Scheduler to create on-demand bookings on the device.
              Without this feature enabled, booking attempts will fail.
            </p>
            <p>
              Would you like to enable ad hoc booking now?
            </p>
          </div>

          {error && (
            <Alert variant="error" className="mt-4">
              <Alert.Icon />
              <Alert.Content>
                <Alert.Description>{error}</Alert.Description>
              </Alert.Content>
            </Alert>
          )}
        </Dialog.Body>

        <Dialog.Footer className="flex-col">
          <Button variant="primary" fullWidth onClick={onEnableAndMap} disabled={isSubmitting}>
            {isSubmitting ? "Enabling..." : "Enable Ad Hoc Booking & Assign"}
          </Button>

          <Button variant="secondary" fullWidth onClick={onMapWithoutEnabling} disabled={isSubmitting}>
            Assign Without Enabling
          </Button>

          <Button variant="text" fullWidth onClick={onCancel} disabled={isSubmitting}>
            Cancel
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
